import Link from 'next/link';
import { ArrowLeft01Icon } from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { cn } from '../../lib/utils';
import { Button } from '../ui/button';

export interface BackHeaderButtonProps {
  /** Accessible label. Defaults to "Back". */
  label?: string;
  className?: string;
  href?: string;
  onClick?: () => void;
}

function BackHeaderButtonIcon() {
  return <HugeiconsIcon icon={ArrowLeft01Icon} strokeWidth={1.75} />;
}

const backButtonClassName =
  'shrink-0 outline-none focus-visible:ring-0 focus-visible:ring-offset-0';

/** Header back control — ghost icon button with ArrowLeft01Icon. */
export function BackHeaderButton({ label = 'Back', className, href, onClick }: BackHeaderButtonProps) {
  if (href) {
    return (
      <Button
        asChild
        variant="iconAction"
        size="icon-action"
        className={cn(backButtonClassName, className)}
      >
        <Link href={href} aria-label={label}>
          <BackHeaderButtonIcon />
        </Link>
      </Button>
    );
  }

  return (
    <Button
      type="button"
      variant="iconAction"
      size="icon-action"
      className={cn(backButtonClassName, className)}
      aria-label={label}
      onClick={onClick}
    >
      <BackHeaderButtonIcon />
    </Button>
  );
}

export interface BackLinkProps {
  href: string;
  label?: string;
  className?: string;
}

/** Link-based back navigation for page headers. */
export function BackLink({ href, label = 'Back', className }: BackLinkProps) {
  return <BackHeaderButton href={href} label={label} className={className} />;
}
